import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/pages/Home";
import Sleep from "@/components/pages/Sleep";
import Mood from "@/components/pages/Mood";
import Support from "@/components/pages/Support.vue";
import Device from "@/components/pages/Device.vue";
import Download from "@/components/pages/Download.vue";
import Video from "@/components/pages/Video.vue";
import Member from "@/components/pages/Member.vue";
import pack from "@/components/pages/pack.vue";
import Index from "@/components/pages/Index.vue";
import Lotus1device from "@/components/pages/Lotus1device.vue";
import Lotus2device from "@/components/pages/Lotus2device.vue";
import Lotus2Rdevice from "@/components/pages/Lotus2Rdevice.vue";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/device",
      name: "Device",
      component: Device
    },
    {
      path: "/sleep",
      name: "Sleep",
      component: Sleep
      // component: resolve => require(['@/components/pages/Sleep'], resolve)
    },
    {
      path: "/mood",
      name: "Mood",
      component: Mood
      // component: resolve => require(['@/components/pages/Mood'], resolve)
    },
    // {
    //   path: "/support",
    //   name: "Support",
    //   // component: Support
    //   component: resolve => require(['@/components/pages/Support'], resolve)
    // },
    {
      path: "/home",
      name: "Home",
      component: Home
      // component: resolve => require(['@/components/pages/Home'], resolve)
    },
    {
      path: "/download",
      name: "Download",
      component: Download
      // component: resolve => require(['@/components/pages/Download'], resolve)
    },
    {
      path: "/video",
      name: "Video",
      component: Video
      // component: resolve => require(['@/components/pages/Video'], resolve)
    },
    {
      path: "/member",
      name: "Member",
      component: Member
      // component: resolve => require(['@/components/pages/Member'], resolve)
    },
    {
      path: "/pack",
      name: "pack",
      component: pack
      // component: resolve => require(['@/components/pages/pack'], resolve)
    },
    {
      path: "/lotus1device",
      name: "Lotus1device",
      component: Lotus1device
    },
    {
      path: "/lotus2device",
      name: "Lotus2device",
      component: Lotus2device
    },
    {
      path: "/lotus2Rdevice",
      name: "Lotus2Rdevice",
      component: Lotus2Rdevice
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js